<era-device-grid-ui [devices]="unassignedDevices$ | async"
                    (selected)="itemSelected($event)">
  <div class="title">
    <h6>Unassigned</h6>
  </div>
  <div class="empty">
    <p>No unassigned devices.</p>
  </div>
</era-device-grid-ui>